import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, throwError } from 'rxjs';
import { switchMap, take, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private isRedirecting = false;

    constructor(
        private readonly auth: AuthService,
        private readonly router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.auth.idTokenClaims$.pipe(
            take(1),
            switchMap((claims) => {
                if (claims?.__raw) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${claims.__raw}`
                        }
                    });
                }

                return next.handle(request).pipe(
                    catchError((error: HttpErrorResponse) => {
                        if (error.status === 401 && !this.isRedirecting) {
                            this.isRedirecting = true;
                            this.router.navigate(['/access-denied']).then(() => {
                                this.isRedirecting = false;
                            });
                        }
                        return throwError(() => error);
                    })
                );
            })
        );
    }
}
